






















































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import ScrollArea from '@/pages/P0918/ScrollArea.vue';
import FaqBox from '@/components/FaqBox.vue';
@Component({
  components: { FaqBox, ScrollArea }
})
export default class P0923 extends Vue {}
